import React from 'react';
import { t, date } from '@lingui/macro';
import { parse } from 'date-fns';
import i18n from 'config/i18n';

const dateOptions = {
  day: 'numeric',
  month: 'long',
  weekday: 'short',
  year: 'numeric',
};

export default function Label({ date }) {
  if (!date) {
    return <span />
  }
  return (
    <span>
      {i18n._(t`${date(parse(date), dateOptions)}`)}
    </span>
  );
}
